import React from 'react';
import { Row } from './Row';

interface GridProps {
  guesses: string[][];
  resultColors: ('empty' | 'G' | 'R')[][];
  activeRow: number;
  wordLength: number;
  flippingTiles: {row: number, tile: number}[];
  onInputChange?: (row: number, col: number, value: string) => void;
}

export const Grid: React.FC<GridProps> = ({
  guesses,
  resultColors,
  activeRow,
  wordLength,
  flippingTiles, // Add this
  onInputChange,
}) => {
  // DEBUG: Log grid render
  // console.log('🎯 Grid rendered - activeRow:', activeRow);
  // console.log('   resultColors:', resultColors.map(row => `[${row.join(',')}]`));
  // console.log('   flippingTiles:', flippingTiles);
  
  return (
    <div className="flex flex-col gap-2">
      {guesses.map((letters, rowIdx) => (
        <Row
          key={rowIdx}
          letters={letters}
          states={resultColors[rowIdx]}
          editable={rowIdx === activeRow}
          flippingTiles={flippingTiles} // Pass to Row
          rowIndex={rowIdx} // Pass row index
          onTileChange={(col, value) => onInputChange?.(rowIdx, col, value)}
        />
      ))}
    </div>
  );
};